<div class="command-center-content container">
    <div class="row m-2">
        <div class="col-12 d-flex">
            <div class="d-block flex-fill">
                <cv-command-center-group-selector></cv-command-center-group-selector>
            </div>

            <button id="gamificationSettingsBtn" type="button" class="btn btn-text btn-icon fill-cerulean ml-3" (click)="openSettings()">
                <svg><use href="../App_Themes/clearview-default/icons/utility/settings.svg#settings"></use></svg>
                <span cvLocalizedText langSection="Common" langKey="Settings">Settings</span>
            </button>
        </div>
    </div>

    <div class="row m-2">
        <div class="subtitle-1 lato-bold col-12 mb-3" cvLocalizedText langSection="Command_Center" langKey="Todays_Glimpse">Today's Glimpse</div>
        <div class="glimpse-container" [ngClass]="gms.glimpseSize" [hidden]="!gms.visibleAreas.Currency">
            <div class="card glimpse-card glimpse-card-marketplace m-2">
                <div class="card-body">
                    <div class="glimpse-header d-flex">
                        <img class="icon-32 glimpse-icon marketplace-icon my-auto mr-3" src="../App_Themes/clearview-default/icons/colorful/marketplace.svg" />
                        <h4 class="my-auto">{{ ms.ordersByRange.today.length ? ms.ordersByRange.today.length : '--' }}</h4>
                        <div id="mktpGlimpseCard" class="btn btn-text ml-auto clickable stretched-link" (click)="openMarketplaceModal()" cvLocalizedText langSection="Common" langKey="View">View</div>
                    </div>
                    <div class="mt-2" cvLocalizedText langSection="Command_Center" langKey="New_Marketplace_Orders">New Marketplace Orders</div>
                </div>
            </div>
        </div>

        <div class="glimpse-container" [ngClass]="gms.glimpseSize" [hidden]="!gms.visibleAreas.Games">
            <div class="card glimpse-card glimpse-card-games m-2">
                <div class="card-body">
                    <div class="glimpse-header d-flex">
                        <img class="icon-32 glimpse-icon game-icon my-auto mr-3" src="../App_Themes/clearview-default/icons/colorful/gamification.svg" />
                        <h4 class="my-auto">{{ gs.activeGames.length ? gs.activeGames.length : '--' }}</h4>
                        <div id="gamesGlimpseCard" class="btn btn-text ml-auto clickable stretched-link" (click)="openGamesModal()" cvLocalizedText langSection="Common" langKey="View">View</div>
                    </div>
                    <div class="mt-2" cvLocalizedText langSection="Command_Center" langKey="Games_Running_Currently">Games Running Currently</div>
                </div>
            </div>
        </div>

        <div class="glimpse-container" [ngClass]="gms.glimpseSize" [hidden]="!gms.visibleAreas.Challenges">
            <div class="card glimpse-card glimpse-card-challenges m-2">
                <div class="card-body">
                    <div class="glimpse-header d-flex">
                        <img class="icon-32 glimpse-icon challenges-icon my-auto mr-3" src="../App_Themes/clearview-default/icons/colorful/challenges.svg" />
                        <h4 class="my-auto">{{ cs.runningChallenges.length ? cs.runningChallenges.length : '--' }}</h4>
                        <div class="btn btn-text ml-auto clickable stretched-link" *ngIf="false" cvLocalizedText langSection="Common" langKey="View">View</div>
                    </div>
                    <div class="mt-2" cvLocalizedText langSection="Command_Center" langKey="Challenges_Running_Currently">Challenges Running Currently</div>
                </div>
            </div>
        </div>

        <div class="glimpse-container" [ngClass]="gms.glimpseSize" [hidden]="!gms.visibleAreas.Awards">
            <div class="card glimpse-card glimpse-card-badges m-2">
                <div class="card-body">
                    <div class="glimpse-header d-flex">
                        <img class="icon-32 glimpse-icon badges-icon my-auto mr-3" src="../App_Themes/clearview-default/icons/colorful/badges.svg" />
                        <h4 class="my-auto">{{ mas.awardedToday.length ? mas.awardedToday.length : '--' }}</h4>
                        <div class="btn btn-text ml-auto clickable stretched-link" *ngIf="false" cvLocalizedText langSection="Common" langKey="View">View</div>
                    </div>
                    <div class="mt-2" cvLocalizedText langSection="Command_Center" langKey="Badges_Awarded_Today">Badges Awarded Today</div>
                </div>
            </div>
        </div>
    </div>

    <div class="row m-2">
        <div class="subtitle-1 lato-bold col-12 my-3" cvLocalizedText langSection="Command_Center" langKey="Overview">Overview</div>
        <div class="col-12">
            <div class="btn-group radio-based">
                <label class="btn btn-secondary btn-sm" id="todayDataBtn" [ngClass]="getButtonClass('Today')" (click)="setOverviewDate('Today')" cvLocalizedText langSection="Controls" langKey="Today">Today</label>
                <label class="btn btn-secondary btn-sm" id="thisWeekDataBtn" [ngClass]="getButtonClass('Week')" (click)="setOverviewDate('Week')" cvLocalizedText langSection="Controls" langKey="Week">Week</label>
                <label class="btn btn-secondary btn-sm" id="thisMonthDataBtn" [ngClass]="getButtonClass('Month')" (click)="setOverviewDate('Month')" cvLocalizedText langSection="Controls" langKey="Month">Month</label>
            </div>
        </div>

        <div class="col-12" [hidden]="!gms.visibleAreas.Coins">
            <div class="card my-3">
                <div class="card-header" cvLocalizedText langSection="Command_Center" langKey="Coins_Awarded_And_Spent">Coins Awarded and Spent</div>
                <div class="card-body command-center-module">
                    <cv-coin-history [overviewDate]="gms.settings.OverviewDate"></cv-coin-history>
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-4" [hidden]="!gms.visibleAreas.Coins">
            <div class="card my-3">
                <div class="card-header" cvLocalizedText langSection="Command_Center" langKey="Marketplace_At_A_Glance">Marketplace at a Glance</div>
                <div class="card-body command-center-module py-0">
                    <cv-marketplace-overview></cv-marketplace-overview>
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-8" [hidden]="!gms.visibleAreas.Awards">
            <div class="card my-3">
                <div class="card-header" cvLocalizedText langSection="Command_Center" langKey="Overview_Of_Badges_Earned">Overview of Badges Earned</div>
                <div class="card-body command-center-module">
                    <cv-badges-earned [awards]="mas.manualAwards"></cv-badges-earned>
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-8" [hidden]="!gms.visibleAreas.Coins">
            <div class="card my-3">
                <div class="card-header" cvLocalizedText langSection="Command_Center" langKey="Top_Coin_Earners">Top Coin Earners</div>
                <div class="card-body command-center-module">
                    <cv-coins-earned [coins]="gms.usersCoinsEarned"></cv-coins-earned>
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-4" [hidden]="!gms.visibleAreas.Games">
            <div class="card my-3">
                <div class="card-header" cvLocalizedText langSection="Command_Center" langKey="Active_Games_By_Type">Active Games By Type</div>
                <div class="card-body command-center-module">
                    <cv-games-running-by-type [activeGames]="gs.activeGames"></cv-games-running-by-type>
                </div>
            </div>
        </div>
    </div>
</div>